import { render, staticRenderFns } from "./CapitalCityLogo.vue?vue&type=template&id=0fedbfd4"
import script from "./CapitalCityLogo.vue?vue&type=script&lang=js"
export * from "./CapitalCityLogo.vue?vue&type=script&lang=js"
import style0 from "./CapitalCityLogo.vue?vue&type=style&index=0&id=0fedbfd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports